// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ju-2";
export var container = "_ju-4";
export var dismissButton = "_ju-3";
export var hasPaddingBottom = "_ju-6";
export var last = "_ju-e";
export var scrollbarThumb = "_ju-c";
export var scrollbarTrack = "_ju-b";
export var selected = "_ju-9";
export var spin = "_ju-1";
export var spinning = "_ju-0";
export var suggestionItem = "_ju-d";
export var suggestionsPanel = "_ju-5";
export var tonePill = "_ju-8";
export var tonesContainer = "_ju-7";
export var unselected = "_ju-a";